import { DataSource, _t } from '@net7/core';
import { TagData } from '@net7/components';

export class MrAdvancedSearchTagsDS extends DataSource {
  protected transform(data): TagData[] {
    const { labels, groups, valueMap } = this.options;
    const mapValue = (v: string) => (valueMap && valueMap[v] !== undefined ? valueMap[v] : _t(v));
    const tags: TagData[] = [];
    const consumed = new Set<string>();

    // Handle grouped params (term_range_dynamic, term_range_interval)
    if (groups) {
      groups.forEach((group) => {
        const groupLabel = _t(group.label);

        if (group.type === 'term_range_dynamic') {
          const { operator, value, unit } = group;
          if (data[value] && data[operator]) {
            const unitText = data[unit] ? ` ${data[unit]}` : '';
            tags.push({ text: `${groupLabel}: ${data[operator]} ${data[value]}${unitText}` });
            [operator, value, unit].filter(Boolean).forEach((k) => consumed.add(k));
          }
        } else if (group.type === 'term_range_interval') {
          const { start, end, unit } = group;
          if (data[start] || data[end]) {
            const startText = data[start] || '';
            const endText = data[end] ? ` - ${data[end]}` : '';
            const unitText = data[unit] ? ` ${data[unit]}` : '';
            tags.push({ text: `${groupLabel}: ${startText}${endText}${unitText}` });
            [start, end, unit].filter(Boolean).forEach((k) => consumed.add(k));
          }
        }
      });
    }

    // Handle remaining params with standard label logic
    Object.keys(data)
      .filter((key) => !consumed.has(key) && data[key])
      .forEach((key) => {
        tags.push({ text: `${labels[key] || key}: ${mapValue(data[key])}` });
      });

    return tags;
  }
}
